import { useAuth0 } from "@auth0/auth0-react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { MainLayout } from "./components/MainLayout";
import { LoadingPage } from "./pages";
import { theme } from "./theme";

export const App: FC = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route
          element={<MainLayout />}
          path="/*"
        />
      </Routes>
    </ThemeProvider>
  );
};